import * as React from 'react'

function HomeIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.666 14.061V28M29.333 16l-12.5-9.087a1.333 1.333 0 00-1.564 0L2.667 16M26 12.99V6a.667.667 0 00-.667-.667h-4a.667.667 0 00-.666.667v3.479M29.333 28H2.667M5.333 14.077V28M22.667 20h-4a.667.667 0 00-.667.667v2.666c0 .369.299.667.667.667h4a.667.667 0 00.666-.667v-2.666a.667.667 0 00-.666-.667zM9.334 28v-7.333A.667.667 0 0110 20h3.334a.666.666 0 01.666.667V28"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { HomeIcon }
